import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import LoginWrapper from "app/authentication/Login/LoginWrapper";
import EnterUsernameAndPasswordV2 from "./EnterUsernamePassword";
import EnterMfa from "app/authentication/Login/EnterMfa";
import EnterNewPassword from "./EnterNewPassword";
const Login = () => {
    const [loginPage, setLoginPage] = useState("UsernamePassword");
    const [loginDetails, setLoginDetails] = useState({
        password: "",
        username: "",
        token: "",
    });
    const [isUsingGoogleAuth, setUsingGoogleAuth] = useState(false);
    const reset = () => {
        setLoginPage("UsernamePassword");
        setLoginDetails({
            password: "",
            username: "",
            token: "",
        });
    };
    const handleRequiresMFa = (username, password) => {
        setLoginDetails({
            username: username,
            password: password,
            token: "",
        });
        setLoginPage("SecurityToken");
    };
    const requiresNewPassword = (username, password, token) => {
        setLoginDetails({
            username: username,
            password: password,
            token: token,
        });
        setLoginPage("NewPassword");
    };
    return (_jsxs(LoginWrapper, { children: [loginPage === "SecurityToken" && (_jsx(EnterMfa, { username: loginDetails.username, password: loginDetails.password, requiresNewPassword: requiresNewPassword, reset: reset, isUsingGoogleAuth: isUsingGoogleAuth })), loginPage === "UsernamePassword" && (_jsx(EnterUsernameAndPasswordV2, { requiresMfa: handleRequiresMFa, requiresNewPassword: requiresNewPassword, setUsingGoogleAuth: setUsingGoogleAuth, isUsingGoogleAuth: isUsingGoogleAuth })), loginPage === "NewPassword" && (_jsx(EnterNewPassword, { username: loginDetails.username, password: loginDetails.password, twoFactorToken: loginDetails.token, reset: reset }))] }));
};
export default Login;
